// extracted by mini-css-extract-plugin
export default {"cardBox":"upsell_cardBox__K1a7f","kioskBoxShadow":"upsell_kioskBoxShadow__mpjqX"};